export const AiIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4L26.5 11.5L34 14L26.5 16.5L24 24L21.5 16.5L14 14L21.5 11.5L24 4Z" fill="#B8860B" opacity="0.9"/>
    <path d="M36 20L37.5 24.5L42 26L37.5 27.5L36 32L34.5 27.5L30 26L34.5 24.5L36 20Z" fill="#B8860B" opacity="0.6"/>
    <path d="M14 28L16 33L21 35L16 37L14 42L12 37L7 35L12 33L14 28Z" fill="#B8860B" opacity="0.4"/>
    <circle cx="24" cy="24" r="22" stroke="#B8860B" strokeWidth="1" opacity="0.2"/>
  </svg>
);
